import { render } from "./StockComponent.vue?vue&type=template&id=73eee2dc&scoped=true"
import script from "./StockComponent.vue?vue&type=script&lang=js"
export * from "./StockComponent.vue?vue&type=script&lang=js"

import "./StockComponent.vue?vue&type=style&index=0&id=73eee2dc&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73eee2dc"]])

export default __exports__